<ng-template #instructionsTemplate><ng-content select="[projectedInstructions]"></ng-content></ng-template>
<ng-template #tooltipTemplate><ng-content select="[projectedTooltip]"></ng-content></ng-template>

<div>

  <!-- DESIGN mode -->
  @if (this.Mode === 'design') {
    <div class="flex-row-top-right">
      <div class="fill-remaining-space">
        @if (this.HasInstructions) {
          @if (this.DisplayName) {
            <div class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
              <span style="color: #EF0000;">*</span>
            }</div>
          }
          <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
        }
        <mat-form-field appearance="outline" [floatLabel]="'always'" [hideRequiredMarker]="true">
          @if (this.ShowLabel && !HasInstructions) {
            <mat-label
              class="design-mode-field-label">{{this.DisplayName}} @if (this.FormField.required) {
              <span style="color: #EF0000;">*</span>
            }</mat-label>
          }
          <input matInput
            type="number"
            placeholder="{{this.PlaceholderText}}"
            min="0.00"
            max="10000.00"
            step="0.01"
            value="{{this.DefaultValue}}"
            disabled
            [required]="this.FormField.required"
            [attr.aria-label]="this.DisplayName" />
          </mat-form-field>
          <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
        </div>
        <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
      </div>
    }

    <!-- DESIGN PREVIEW or INSTANCE mode (no format preview) -->
    @if (((this.Mode === 'preview') || (this.Mode === 'instance')) && (! this.ShowFormattedValue)) {
      <div
        class="flex-row-top-right">
        <div class="fill-remaining-space">
          @if ((this.ControlType === 'Reactive Forms') && (this.FormControl !== null)) {
            @if (this.HasInstructions) {
              @if (this.DisplayName) {
                <div class="field-label">
                  {{this.DisplayName}}
                  @if (this.FormField.required) {
                    <span style="color: #EF0000;">*</span>
                  }
                </div>
              }
              <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
            }
            <mat-form-field appearance="outline" [floatLabel]="'always'" [hideRequiredMarker]="true" subscriptSizing="dynamic">
              @if (this.ShowLabel && !this.HasInstructions && !FieldIsInGrid) {
                <mat-label
                  class="field-label">
                  {{this.DisplayName}}
                  @if (this.FormField.required) {
                    <span style="color: #EF0000;">*</span>
                  }
                </mat-label>
              }
              @if ((! this.ReadOnly) && (! this.ShowFormattedValue)) {
                <input matInput
                  matInputDecimalFormat
                  type="text"
                  pattern="^-?[0-9.]+"
                  id="{{this.MatInputId}}"
                  placeholder="{{this.PlaceholderText}}"
                  step="{{this.DecimalStepIncrementExpr}}"
                  [formControl]="this.FormControl"
                  (blur)="this.handleOnBlur()"
                  (focus)="this.handleOnFocus($event)"
                  [required]="this.FormField.required"
                  [attr.aria-label]="this.DisplayName" />
                }
                @if (this.ReadOnly) {
                  <input matInput
                    matInputDecimalFormat
                    readonly
                    type="number"
                    id="{{this.MatInputId}}"
                    placeholder="{{this.PlaceholderText}}"
                    step="{{this.DecimalStepIncrementExpr}}"
                    [formControl]="this.FormControl"
                    (blur)="this.handleOnBlur()"
                    (focus)="this.handleOnFocus($event)"
                    [required]="this.FormField.required"
                    [attr.aria-label]="this.DisplayName" />
                  }
                </mat-form-field>
                <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
              }
            </div>
            <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
          </div>
        }

        <!-- DESIGN PREVIEW or INSTANCE mode (with format preview) -->

        @if (((this.Mode === 'preview') || (this.Mode === 'instance')) && this.ShowFormattedValue) {
          <div
            class="flex-row-top-right">
            <div class="fill-remaining-space">
              @if ((this.ControlType === 'Reactive Forms') && (this.FormControl !== null)) {
                @if (this.HasInstructions) {
                  @if (this.DisplayName) {
                    <div class="field-label">
                      {{this.DisplayName}}
                      @if (this.FormField.required) {
                        <span style="color: #EF0000;">*</span>
                      }
                    </div>
                  }
                  <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
                }
                <mat-form-field appearance="outline" [floatLabel]="'always'" [hideRequiredMarker]="true">
                  @if (this.ShowLabel && !this.HasInstructions) {
                    <mat-label class="field-label">
                      {{this.DisplayName}}
                      @if (this.FormField.required) {
                        <span style="color: #EF0000;">*</span>
                      }
                    </mat-label>
                  }
                  <input matInput
                    matInputDecimalFormat
                    [digitsAfterDecimal]="this.DigitsToShow"
                    [showTrailingZeroes]="this.ShowTrailing"
                    type="text"
                    pattern="^-?[0-9.,]+"
                    id="{{this.MatInputId}}"
                    placeholder="{{this.PlaceholderText}}"
                    step="{{this.DecimalStepIncrementExpr}}"
                    (focus)="this.handleOnFocus($event)"
                    (blur)="this.handleOnBlur()"
                    (ngModelChange)="this.onChange()"
                    [formControl]="this.FormControl"
                    [required]="this.FormField.required"
                    [attr.aria-label]="this.DisplayName" />
                  </mat-form-field>
                  <ng-container *ngTemplateOutlet="instructionsTemplate"></ng-container>
                }
              </div>
              @if (this.ShowFormattedValue && this.hasFocus) {
                <div class="show-formatted-value-formatted-value-div">
                  @if (this.FormControl !== null && this.NumberFormatPreview != '') {
                    preview:&nbsp;<span>{{this.NumberFormatPreview}}</span>
                  }
                </div>
              }
              <ng-container *ngTemplateOutlet="tooltipTemplate"></ng-container>
            </div>
          }
        </div>
